import { css } from "@emotion/css";
import type { FeatureCollection, Geometry } from "geojson";
import { type Properties, signal } from "signlets";

import { geocode } from "../geocode";
import type { Bounds } from "../model";
import { loadKml } from "../world/kml";
import { Button } from "./Button";
import { Field } from "./Field";
import { Overlay } from "./Overlay";

const style = css`
  position: absolute;
  bottom: 1rem;
  left: 1rem;

  form {
    display: flex;

    .field {
      flex-direction: row;

      svg {
        width: 1.25rem;
        height: 1.25rem;
      }

      input {
        flex: 1;
      }
    }
  }

  .container {
    display: flex;
    gap: 1rem;
  }
`;

type ControlsProps = {
  onGeocode: (_: Bounds | undefined) => void;
  onOverlay: (_: FeatureCollection<Geometry> | undefined) => void;
};

export const Controls = ({
  onGeocode,
  onOverlay,
}: Properties<ControlsProps>) => {
  const [value, setValue] = signal("");

  const onInput = ({
    currentTarget,
  }: Event & { currentTarget: HTMLInputElement }) =>
    setValue(currentTarget.value);

  const onSubmit = async (event: Event) => {
    event.preventDefault();
    onGeocode(await geocode(value()));
    setValue("");
  };

  const selectOverlay = () => {
    onOverlay(undefined);
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".kml,.kmz";
    input.addEventListener("change", async () => {
      const [file] = Array.from(input.files ?? []);
      if (file) {
        const overlay = await loadKml(file);
        onOverlay(overlay);
      }
    });
    input.click();
  };

  return (
    <div class={style}>
      <Overlay>
        <div class="container">
          <form onSubmit={onSubmit}>
            <Field label="" class="field">
              <svg fill="currentColor" viewBox="0 0 16 16">
                <path d="M15,14.3L10.7,10c1.9-2.3,1.6-5.8-0.7-7.7S4.2,0.7,2.3,3S0.7,8.8,3,10.7c2,1.7,5,1.7,7,0l4.3,4.3L15,14.3z M2,6.5	C2,4,4,2,6.5,2S11,4,11,6.5S9,11,6.5,11S2,9,2,6.5z" />
              </svg>
              <input
                type="search"
                value={value()}
                onInput={onInput}
                placeholder="Location or MGRS"
              />
            </Field>
          </form>
          <Button onClick={selectOverlay}>KML</Button>
        </div>
      </Overlay>
    </div>
  );
};
